<template>
  <div>
    <b-row>
      <b-col>
        <AppEchartBar
          class="mt-1"
          style="width:850px; height:320px"
          :option-data="option"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol,
// BCard, BCardText,
} from 'bootstrap-vue'
import axios from '@axios'
// import * as echarts from 'echarts'
import AppEchartBar from './AppEchartBar.vue'

export default {
  components: {
    AppEchartBar,
    BRow,
    BCol,
    // BCardCode,
    // BCardText,
  },
  data() {
    return {
      date: {
        wid: this.$route.query.wid,
        dateFrom: '',
      },
      option: {
        legend: {
          left: 43,
          bottom: 290,
          textStyle: {
            color: '#fff',
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          position(point, params, dom, rect, size) {
            // point[0] is the x position of the mouse, point[1] is the y position
            const x = point[0] < size.viewSize[0] / 2 ? point[0] + 10 : point[0] - size.contentSize[0] - 10
            return [x, point[1]]
          },
          // eslint-disable-next-line consistent-return
          formatter(params) {
            if (params.length > 3) {
              return `${params[0].name} <br />
                ${params[0].seriesName}: ${params[0].value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} PCU <br />
                ${params[1].seriesName}: ${params[1].value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} PCU <br />
                ${params[2].seriesName}: ${params[2].value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} PCU <br />
                ${params[3].seriesName}: ${params[3].value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} PCU
              `
            } if (params.length === 3) {
              return `${params[0].name} <br />
                ${params[0].seriesName}: ${params[0].value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} PCU <br />
                ${params[1].seriesName}: ${params[1].value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} PCU <br />
                ${params[2].seriesName}: ${params[2].value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} PCU
              `
            } if (params.length === 2) {
              return `${params[0].name} <br />
                ${params[0].seriesName}: ${params[0].value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} PCU <br />
                ${params[1].seriesName}: ${params[1].value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} PCU
              `
            } if (params.length === 1) {
              return `${params[0].name} <br />
                ${params[0].seriesName}: ${params[0].value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} PCU
              `
            }
          },
        },
        xAxis: [
          {
            type: 'category',
            splitLine: { show: false },
            // data: ['Mon', 'Tue', 'Wen', 'Thu', 'Fri', 'Sat', 'Sun'],
            data: [],
            axisLabel: {
              color: '#fff',
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            splitLine: { show: false },
            axisLabel: {
              color: '#fff',
            },
          },
        ],
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 10,
          },
          {
            start: 0,
            end: 10,
          },
        ],
        grid: {
          width: '70%',
          height: '40%',
          right: 170,
          top: 45,
        },
        series: [
          {
            name: 'Phase1',
            type: 'bar',
            // data: [39, 86, 32, 15, 47, 24, 44],
            data: [],
            barMaxWidth: '15%',
            barMinWidth: '5px',
            itemStyle: {
              barBorderRadius: [5, 5, 0, 0],
              color: '#2effc9',
            },
            // label: {
            //   show: true,
            //   position: 'top',
            //   color: '#2effc9',
            //   fontSize: '12',
            //   // formatter: '{c}',
            //   formatter(d) {
            //     return d.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            //   },
            // },
          },
          {
            name: 'Phase2',
            type: 'bar',
            // data: [16, 68, 69, 84, 34, 59, 56],
            data: [],
            barMaxWidth: '15%',
            barMinWidth: '5px',
            itemStyle: {
              barBorderRadius: [5, 5, 0, 0],
              color: '#24ffeb',
            },
            // label: {
            //   show: true,
            //   position: 'top',
            //   color: '#24ffeb',
            //   fontSize: '12',
            //   // formatter: '{c}',
            //   formatter(d) {
            //     return d.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            //   },
            // },
          },
          {
            name: 'Phase3',
            type: 'bar',
            // data: [62, 37, 79, 66, 61, 49, 38],
            data: [],
            barMaxWidth: '15%',
            barMinWidth: '5px',
            itemStyle: {
              barBorderRadius: [5, 5, 0, 0],
              color: '#43BAFE',
            },
            // label: {
            //   show: true,
            //   position: 'top',
            //   color: '#43BAFE',
            //   fontSize: '12',
            //   // formatter: '{c}',
            //   formatter(d) {
            //     return d.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            //   },
            // },
          },
          {
            name: '',
            type: 'bar',
            // data: [84, 32, 50, 41, 20, 74, 45],
            data: [],
            barMaxWidth: '15%',
            barMinWidth: '5px',
            itemStyle: {
              barBorderRadius: [5, 5, 0, 0],
              color: '#80eeff',
            },
            // label: {
            //   show: true,
            //   position: 'top',
            //   color: '#80eeff',
            //   fontSize: '12',
            //   // formatter: '{c}',
            //   formatter(d) {
            //     return d.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            //   },
            // },
          },
        ],
      },
      check: '',
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.checkPhase()
    this.setToday()
    this.graphBar()
  },
  mounted() {
    this.interval = setInterval(() => {
      this.graphBar()
    }, 300000)
  },
  methods: {
    graphBar() {
      axios.post('/graphTrafficPCU-Week', { wid: this.$route.query.wid })
        .then(response => {
          this.resetChart()
          this.xAxisData = []
          this.xAxisData = response.data
          if (this.check === 4) {
            this.xAxisData.forEach(value => {
              this.option.xAxis[0].data.push(value.Date_Name)
              this.option.series[0].data.push(value.Phase1_PCU)
              this.option.series[1].data.push(value.Phase2_PCU)
              this.option.series[2].data.push(value.Phase3_PCU)
              this.option.series[3].data.push(value.Phase4_PCU)
              this.option.series[2].itemStyle.barBorderRadius = [5, 5, 0, 0]
              this.option.series[3].itemStyle.barBorderRadius = [5, 5, 0, 0]
              this.option.series[3].name = 'Phase4'
            })
          }
          if (this.check === 3) {
            this.xAxisData.forEach(value => {
              this.option.xAxis[0].data.push(value.Date_Name)
              this.option.series[0].data.push(value.Phase1_PCU)
              this.option.series[1].data.push(value.Phase2_PCU)
              this.option.series[2].data.push(value.Phase3_PCU)
            })
          }
        })
        .catch(error => {
          console.log(error)
        })
    },

    checkPhase() {
      axios
        .post('/checkPhaseTraffic', { wid: this.$route.query.wid })
        .then(response => {
          this.check = response.data[0].PhaseNo
        })
        .catch(error => {
          console.log(error)
        })
    },

    setToday() {
      const p = new Date()
      const month = (`0${p.getMonth() + 1}`).slice(-2)
      const date = (`0${p.getDate()}`).slice(-2)
      const year = p.getFullYear()
      this.date.dateFrom = `${year}-${month}-${date}`
      // this.date.dateTo = new Date().toJSON().slice(0, 10).replace(/-/g, '-')
    },
    resetChart() {
      this.option.xAxis[0].data.splice(0)
      this.option.series[0].data.splice(0)
      this.option.series[1].data.splice(0)
      this.option.series[2].data.splice(0)
      this.option.series[3].data.splice(0)
    },
  },
}
</script>

<style scoped>

</style>
